import Image from 'next/image';
import PageBanner, { PageBannerProps } from '@/components/_rebrand/PageBanner';
import { parseHtml } from '@/lib/parse-html';

const displayProps = {
  title: '',
  description: '',
  descriptionTwo: '',
  customerInterfaceImage: null,
  backgroundImage: null,
  backgroundImageTwo: null,
  showNewTag: false,
} as PageBannerProps;


interface FeatureImageFromCraft {
  url: string;
  title: string;
  width: number;
  height: number;
}

interface ModuleProductFeatureHighlight {
      backgroundColor: string,
      featuredImage: FeatureImageFromCraft,
      headline: string,
      description: string,
      hideSection: boolean,
      showNewLabel: boolean,
}

const formImageTag = (image: FeatureImageFromCraft): PageBannerProps['customerInterfaceImage'] => {
  const data = Array.isArray(image) ? image[0] : image;

  return <Image src={data.url} width={data.width} height={data.height} alt={data.title} className="w-[90%] md:w-full rounded-tl-[16px] md:rounded-tl-0 md:rounded-tr-[16px]" />
}

const setDynamicDisplayPropAttributes = (feature: ModuleProductFeatureHighlight) => {
  displayProps.title = feature.headline;
  displayProps.description = feature.description ? parseHtml(feature.description) : '';
  displayProps.customerInterfaceImage = formImageTag(feature.featuredImage);
  displayProps.showNewTag = feature.showNewLabel;
};

const FeatureHighlight = ({ entry }) => {
  const data = Array.isArray(entry?.moduleProductFeatureHighlight)
    ? entry.moduleProductFeatureHighlight[0]
    : entry?.moduleProductFeatureHighlight;

  setDynamicDisplayPropAttributes(data);

  displayProps.backgroundColor = (data.backgroundColor == 'themeColor') ? entry.moduleProductTheme[0].color : data.backgroundColor;

  if (data.hideSection) {
    return null;
  }

  return (
    <PageBanner {...displayProps} />
  );
};

export default FeatureHighlight;

